<template>
  <VueRecaptcha
    sitekey="6LeT5d4ZAAAAANjtHhNbc-n6pkXhfL2g0eyoEjWN"
    @verify="onVerify"
    theme="dark"
    :loadRecaptchaScript="true"
    :language="language"
    ref="recaptcha"
  ></VueRecaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'GSRecaptcha',
  props: {
    onVerify: {
      type: Function,
      required: true
    },
    language: {
      type: String,
      required: true
    }
  },
  components: { VueRecaptcha },
  methods: {
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GSRecaptcha.vue